import {UnLitElement} from "../../../common/elements";
import {customElement, state} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import type {Nullable} from "../../../bootstrap/common/types";

@customElement("eop-read-aloud-voice-test")
export class EopReadAloudVoiceTest extends UnLitElement {

    @state()
    private voices: SpeechSynthesisVoice[] = [];
    @state()
    private activeVoice: Nullable<SpeechSynthesisVoice> = null;

    private speechSynth: SpeechSynthesis;

    public constructor() {
        super();
        this.speechSynth = window.speechSynthesis;
        this.speechSynth.addEventListener("voiceschanged", () => {
            this.voices = this.speechSynth.getVoices();
            console.log(`>>> Voices changed, now there are ${this.voices.length} voices available.`);
        });
    }

    public render(): TemplateResult {
        return html`
            <div class="selection-row">
                <label>Stimme:
                    <select name="voice-selector" @change=${this.handleVoiceChange}>
                        <option value="">Bitte auswählen ...</option>
                        ${this.renderDropdownOptions()}
                    </select>
                </label>
            </div>
            <div class="button-row">
                <button class="uni-button primary next" .disabled=${!this.activeVoice} @click=${this.readAloud}>Vorlesen</button>
                <button class="uni-button primary next" @click=${this.stop}>Stop</button>
                <button class="uni-button primary next" @click=${this.pause}>Pause</button>
                <button class="uni-button primary next" @click=${this.resume}>Weiter</button>
                <button class="uni-button primary next" @click=${this.triggerVoiceLoad}>Stimmen laden</button>
            </div>`;
    }

    private renderDropdownOptions(): TemplateResult[] {
        return this.voices
            .sort((v1, v2) => v1.lang < v2.lang ? -1 : 1)
            .map(voice => html`
                <option value=${voice.name}>
                    ${voice.lang}: ${voice.name}
                </option>
            `);
    }

    private handleVoiceChange(event: Event): void {
        const value = (event.target as HTMLSelectElement).value;
        this.activeVoice = this.voices.filter(voice => voice.name === value).first();

        const utterance = new SpeechSynthesisUtterance(`${this.activeVoice!.name}`);
        utterance.voice = this.activeVoice;
        this.speechSynth.speak(utterance);
        console.log(`>>> Voice changed to ${this.activeVoice?.name ?? "none"}.`);
    }

    private readAloud(): void {
        const text = document.body.querySelector(".text-image-text")?.textContent ?? "";
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.voice = this.activeVoice;
        this.speechSynth.speak(utterance);
    }

    private stop(): void {
        this.speechSynth.cancel();
    }

    private pause(): void {
        this.speechSynth.pause();
    }

    private resume(): void {
        this.speechSynth.resume();
    }

    private triggerVoiceLoad(): void {
        this.voices = this.speechSynth.getVoices();
        const utterance = new SpeechSynthesisUtterance(`${this.voices.length} Stimmen verfügbar.`);
        this.activeVoice = this.voices[0];
        utterance.voice = this.activeVoice;
        this.speechSynth.speak(utterance);
        this.activeVoice = null;
        console.log(`>>> Voices loaded, now there are ${this.voices.length} voices available.`);
    }
}